import React, { useEffect } from 'react';
import './ManifestoPage.css';

const ManifestoPage = () => {
    useEffect(() => {
        // Animate elements on mount
        const animateElements = () => {
            const elements = document.querySelectorAll('.animate-line');
            elements.forEach((element, index) => {
                setTimeout(() => {
                    element.classList.add('visible');
                }, 300 + (index * 200));
            });
        };

        animateElements();
    }, []);

    return (
        <div className="manifesto-page">
            <div className="manifesto-content">
                <header className="manifesto-header">
                    <h1 className="animate-line">Interference is the message.</h1>
                </header>

                <div className="manifesto-text">
                    <p className="animate-line">
                        I work at the intersection of art, code, and systems—not to celebrate technology, but to dissect it.
                    </p>

                    <p className="animate-line">
                        I build tools, worlds, and experiences that expose the mechanics of power:
                    </p>

                    <ul className="manifesto-list">
                        <li className="animate-line">🌀 automated labor in VR supermarkets</li>
                        <li className="animate-line">🎯 the logic of surveillance in arcade games</li>
                        <li className="animate-line">📡 the ghosts in our infrastructure through 3D scans and live data feeds</li>
                    </ul>

                    <p className="animate-line">
                        I use interactivity as a weapon against passivity. I believe interfaces are political.
                    </p>

                    <p className="animate-line">
                        Every line of code is a choice. Every animation, a form of language.
                    </p>

                    <p className="animate-line">
                        My practice is rooted in a deep respect for craft, but driven by a refusal to be confined by industry categories. I am not "just" a designer, developer, or artist. I am a cartographer of hidden systems—mapping the invisible with code, cameras, sound, and spatial design.
                    </p>

                    <p className="animate-line">
                        I believe the future isn't something we consume—it's something we intervene in.
                    </p>

                    <div className="manifesto-actions">
                        <p className="animate-line">So I build friction.</p>
                        <p className="animate-line">I build feedback loops.</p>
                        <p className="animate-line">I build platforms that look back.</p>
                    </div>

                    <p className="animate-line">
                        Because the world isn't short of content.
                    </p>

                    <p className="animate-line manifesto-emphasis">
                        It's short of confrontation.
                    </p>
                </div>

                <footer className="manifesto-footer">
                    <p className="animate-line">© <span id="year"></span> Jacob Faulkner All rights reserved.</p>
                    <p className="animate-line">No cookies, no tracking, no bullshit.</p>
                </footer>
            </div>
        </div>
    );
};

export default ManifestoPage; 